import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";
import { Link as RouterLink } from "react-router";

interface AddPaymentMethodCardProps {
  severity?: "warning" | "error";
}

export function AddPaymentMethodCard({
  severity = "warning",
}: AddPaymentMethodCardProps) {
  const colorScheme =
    severity === "error"
      ? {
          card: "border-red-200 bg-red-50",
          icon: "text-red-600",
          description: "text-red-700",
          button: "bg-red-600 hover:bg-red-700",
        }
      : {
          card: "border-yellow-500 bg-yellow-50",
          icon: "text-yellow-600",
          description: "text-yellow-700",
          button: "bg-yellow-600 hover:bg-yellow-700",
        };

  return (
    <Card className={`shadow-none ${colorScheme.card}`}>
      <form>
        <CardHeader className="p-4 pb-0">
          <div className="flex items-center gap-2">
            <AlertTriangle className={`h-5 w-5 ${colorScheme.icon}`} />
            <CardTitle className="text-md">
              Billing Information Required
            </CardTitle>
          </div>
          <CardDescription
            className={`${colorScheme.description} hidden md:block`}
          >
            Please add a payment method and billing address to continue using
            our services. This information is required for invoice processing
            and to ensure uninterrupted access.
          </CardDescription>
        </CardHeader>
        <CardContent className="grid gap-2.5 p-4">
          <Button
            className={`w-full ${colorScheme.button} text-white shadow-none`}
            size="sm"
            asChild
          >
            <RouterLink to="/settings">Complete Billing Setup</RouterLink>
          </Button>
        </CardContent>
      </form>
    </Card>
  );
}
